import { request } from './api';
import type { AuthUser } from './authService';

export interface DoctorListResponse {
  doctors: AuthUser[];
  total: number;
}

export interface DoctorCreateInput {
  email: string;
  password: string;
  full_name: string | null;
  is_active: boolean;
}

export interface DoctorUpdateInput {
  email?: string;
  password?: string;
  full_name?: string | null;
  is_active?: boolean;
}

export function listDoctors(token: string) {
  return request<DoctorListResponse>('/admin/doctors', { token });
}

export function createDoctor(payload: DoctorCreateInput, token: string) {
  return request<AuthUser>('/admin/doctors', {
    method: 'POST',
    body: JSON.stringify(payload),
    token,
  });
}

export function updateDoctor(doctorId: string, payload: DoctorUpdateInput, token: string) {
  return request<AuthUser>(`/admin/doctors/${doctorId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
    token,
  });
}

export function deleteDoctor(doctorId: string, token: string) {
  return request<void>(`/admin/doctors/${doctorId}`, {
    method: 'DELETE',
    token,
  });
}
